import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls window to top on every route change unless the URL contains a hash
 * (anchor scroll target). This keeps in-page anchor navigation working while
 * fixing the issue of new pages opening scrolled down.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let anchor / hash navigation take over
    // Scroll immediately and again after next paint to catch any layout shifts
    // that happen when framer-motion elements measure themselves post-mount.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    const raf = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);

  return null;
}
